<template>
  <div>
    <b-modal
      id="modal-picture"
      v-model="pictureModal"
      hide-footer
      hide-header
      centered
      size="lg"
      modal-class="asset-photo-modal"
    >
      <div class="asset-photo-modal__header">
        <div class="asset-photo-modal__title">
          <feather-icon
            icon="ImageIcon"
            size="16"
          />
          <span>Asset Photo</span>
        </div>
        <button
          type="button"
          class="asset-photo-modal__close"
          @click="pictureModal = false"
        >
          <feather-icon
            icon="XIcon"
            size="18"
          />
        </button>
      </div>

      <div class="asset-photo-modal__stage">
        <img
          :src="previewPhoto || assetPhoto"
          alt="Asset Photo"
          class="asset-photo-modal__img"
        >
      </div>

      <div class="asset-photo-modal__footer">
        <b-button
          :href="previewPhoto || assetPhoto"
          target="_blank"
          variant="outline-primary"
          size="sm"
        >
          <feather-icon
            icon="DownloadIcon"
            size="14"
            class="mr-50"
          />
          Download
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          @click="pictureModal = false"
        >
          Close
        </b-button>
      </div>
    </b-modal>

    <b-card
no-body
class="mb-0"
>
      <b-form @submit.prevent="submitUpdate">
        <b-row class="match-height">
          <b-col lg="12">
            <b-card title="Asset Update By Finance">
              <b-row>
                <b-col cols="6">
                  <b-button
                    type="button"
                    variant="primary"
                    class="mr-1"
                    @click="previous()"
                  >
                    <feather-icon
icon="ArrowLeftIcon"
size="16"
class="align-middle"
/>
                    Back
                  </b-button>
                </b-col>
                <b-col
cols="6"
class="d-flex justify-content-end"
>
                  <div
                    v-if="previewPhoto || assetPhoto"
                    class="asset-photo-card"
                    @click="showModal"
                  >
                    <img
                      :src="previewPhoto || assetPhoto"
                      alt="Asset Photo"
                      class="asset-photo-card__img"
                    >
                    <div class="asset-photo-card__overlay">
                      <feather-icon
                        icon="ZoomInIcon"
                        size="16"
                      />
                      <span>Preview</span>
                    </div>
                  </div>
                </b-col>

                <b-col cols="12">
                  <div class="divider mt-2 mb-2" />

                  <!-- Update metadata -->
                  <b-form-group
                    label="Reason / Note *"
                    label-cols-md="12"
                  >
                    <b-form-input
                      v-model="assetUpdateNote"
                      placeholder="Alasan perubahan..."
                      required
                    />
                  </b-form-group>
                  <b-form-group
label="New Asset Photo (optional)"
label-cols-md="12"
>
                    <b-form-file
                      ref="uploadPhotoRef"
                      placeholder="Choose photo or drop it here."
                      drop-placeholder="Drop photo here..."
                      accept="image/*"
                      @change="handlePhotoChange"
                    />
                  </b-form-group>
                  <b-form-group
label="Supporting Documents (optional)"
label-cols-md="12"
>
                    <b-form-file
                      ref="uploadAttachmentsRef"
                      placeholder="Choose files or drop here."
                      drop-placeholder="Drop files here..."
                      multiple
                      @change="handleFilesUploadPhoto"
                    />
                  </b-form-group>

                  <hr>
                  <div class="divider mt-2 mb-2" />

                  <!-- Editable asset fields -->
                  <b-form-group
label="Item ID"
label-cols-md="12"
>
                    <b-form-input
:value="item.item ? item.item.item_code : ''"
readonly
/>
                  </b-form-group>
                  <b-form-group
label="Asset ID"
label-cols-md="12"
>
                    <b-form-input
v-model="item.asset_number"
readonly
/>
                  </b-form-group>
                  <b-form-group
label="Ref ID"
label-cols-md="12"
>
                    <b-form-input
v-model="form.asset_ref_id"
placeholder="Ref ID"
/>
                  </b-form-group>
                  <b-form-group
label="Local ID"
label-cols-md="12"
>
                    <b-form-input
v-model="form.asset_local_id"
placeholder="Local ID"
/>
                  </b-form-group>
                  <b-form-group
label="Asset Group"
label-cols-md="12"
>
                    <b-form-input
v-model="form.asset_category"
placeholder="Asset Group"
required
/>
                  </b-form-group>
                  <b-form-group
label="Description"
label-cols-md="12"
>
                    <b-form-input
v-model="form.asset_description"
placeholder="Asset Description"
required
/>
                  </b-form-group>
                  <b-form-group
label="Note"
label-cols-md="12"
>
                    <b-form-input
v-model="form.asset_note"
placeholder="Asset Note"
/>
                  </b-form-group>
                  <b-form-group
label="GPS"
label-cols-md="12"
>
                    <b-form-input
v-model="form.asset_gps"
placeholder="Asset GPS"
/>
                  </b-form-group>
                  <b-form-group
label="Date of Acquisition"
label-cols-md="12"
>
                    <b-form-input
v-model="form.asset_date_of_acquistion"
type="date"
required
/>
                  </b-form-group>
                  <b-form-group
label="Acquisition Value"
label-cols-md="12"
>
                    <b-form-input
v-model="form.asset_acquistion_value"
placeholder="Acquisition Value"
type="number"
required
/>
                  </b-form-group>
                  <b-form-group
label="Depreciation Method"
label-cols-md="12"
>
                    <b-form-input
v-model="form.asset_depreciation_method"
placeholder="Depreciation Method"
required
/>
                  </b-form-group>
                  <b-form-group
label="Residual Value"
label-cols-md="12"
>
                    <b-form-input
v-model="form.asset_residual_value"
placeholder="Residual Value"
type="number"
/>
                  </b-form-group>
                  <b-form-group
label="Market Value"
label-cols-md="12"
>
                    <b-form-input
v-model="form.asset_market_value"
placeholder="Market Value"
type="number"
/>
                  </b-form-group>
                  <b-form-group
label="Asset Condition"
label-cols-md="12"
>
                    <b-form-input
v-model="form.asset_condition"
placeholder="Condition"
required
/>
                  </b-form-group>
                  <b-form-group
label="Asset Status"
label-cols-md="12"
>
                    <v-select-new
                      v-model="form.asset_status"
                      :options="['active', 'non-active-breakdown', 'repair/maintenance']"
                    />
                  </b-form-group>
                  <b-form-group
label="Asset Address"
label-cols-md="12"
>
                    <b-form-input
v-model="form.asset_address"
placeholder="Asset Address"
/>
                  </b-form-group>
                  <b-form-group
label="Asset Responsible"
label-cols-md="12"
>
                    <b-form-input
v-model="form.asset_responsible"
placeholder="Asset Responsible"
required
/>
                  </b-form-group>
                  <b-form-group
label="Serial Number"
label-cols-md="12"
>
                    <b-form-input
v-model="form.asset_serial_no"
placeholder="Serial Number"
/>
                  </b-form-group>
                  <b-form-group
label="Warranty"
label-cols-md="12"
>
                    <b-form-input
v-model="form.asset_warranty"
placeholder="Warranty"
/>
                  </b-form-group>
                  <b-form-group
label="Insurance"
label-cols-md="12"
>
                    <b-form-input
v-model="form.asset_insurance"
placeholder="Insurance"
/>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-button
                type="submit"
                variant="primary"
                class="mt-2"
                :disabled="submitButtonDisabled"
              >
                Submit Update Request
              </b-button>
            </b-card>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BFormInput, BForm, BFormFile, BButton, BCard,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from 'axios'
import moment from 'moment-timezone'
import apiEndpoints from '@/constants/apiEndpoints'

export default {
  components: {
    BFormFile, BCard, BRow, BCol, BFormGroup, BFormInput, BForm, BButton,
  },
  data() {
    return {
      attachments: [],
      photoFile: null,
      previewPhoto: '',
      assetUpdateNote: '',
      pictureModal: false,
      assetPhoto: '',
      item: {},
      assetId: '',
      submitButtonDisabled: false,
      form: {
        asset_ref_id: '',
        asset_local_id: '',
        asset_category: '',
        asset_description: '',
        asset_note: '',
        asset_gps: '',
        asset_date_of_acquistion: '',
        asset_acquistion_value: '',
        asset_depreciation_method: '',
        asset_residual_value: '',
        asset_market_value: '',
        asset_condition: '',
        asset_status: '',
        asset_address: '',
        asset_responsible: '',
        asset_serial_no: '',
        asset_warranty: '',
        asset_insurance: '',
      },
    }
  },
  mounted() {
    this.getDetail()
  },
  methods: {
    submitUpdate() {
      this.submitButtonDisabled = true
      const formData = new FormData()
      formData.append('asset_id', this.assetId)
      formData.append('asset_is_updated_note', this.assetUpdateNote)
      formData.append('time', moment())

      // Append all editable fields
      Object.keys(this.form).forEach(key => {
        if (this.form[key] !== null && this.form[key] !== undefined) {
          formData.append(key, this.form[key])
        }
      })

      // New photo
      if (this.photoFile) {
        formData.append('photo', this.photoFile, this.photoFile.name)
      }

      // Supporting documents
      if (this.attachments && this.attachments.length > 0) {
        for (let i = 0; i < this.attachments.length; i += 1) {
          formData.append('attachments', this.attachments[i], this.attachments[i].name)
        }
      }

      const userToken = this.$cookies.get('userToken')
      const headers = {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${userToken}`,
      }

      axios
        .post(
          `${process.env.VUE_APP_API_URL}${apiEndpoints.API_UPDATE_ASSET}`,
          formData,
          { headers },
        )
        .then(response => {
          if (response.data.success === true) {
            this.$toast({
              component: ToastificationContent,
              props: { title: 'Asset Update Request Success', icon: 'CheckIcon', variant: 'success' },
            })
            this.$router.replace({ name: 'apps-procurement-assets-list' })
          } else {
            this.submitButtonDisabled = false
            this.$toast({
              component: ToastificationContent,
              props: { title: 'Asset Update Request Failed', icon: 'AlertTriangleIcon', variant: 'danger' },
            })
          }
        })
        .catch(() => {
          this.submitButtonDisabled = false
          this.$toast({
            component: ToastificationContent,
            props: { title: 'Asset Update Request Failed', icon: 'AlertTriangleIcon', variant: 'danger' },
          })
        })
    },
    handlePhotoChange(e) {
      const file = (e.target.files || e.dataTransfer.files)[0]
      if (file) {
        this.photoFile = file
        this.previewPhoto = URL.createObjectURL(file)
      }
    },
    handleFilesUploadPhoto(e) {
      this.attachments = e.target.files || e.dataTransfer.files
    },
    showModal() {
      this.pictureModal = true
    },
    getDetail() {
      this.item = JSON.parse(localStorage.getItem('assetDetail')) || {}
      this.assetId = this.item.asset_id

      if (this.item.asset_photo) {
        this.assetPhoto = `${process.env.VUE_APP_API_URL}upload/${this.item.asset_photo}`
      }

      // Pre-fill form with current values
      this.form.asset_ref_id = this.item.asset_ref_id || ''
      this.form.asset_local_id = this.item.asset_local_id || ''
      this.form.asset_category = this.item.asset_category || ''
      this.form.asset_description = this.item.asset_description || ''
      this.form.asset_note = this.item.asset_note || ''
      this.form.asset_gps = this.item.asset_gps || ''
      this.form.asset_date_of_acquistion = this.item.asset_date_of_acquistion
        ? moment.utc(this.item.asset_date_of_acquistion).format('YYYY-MM-DD') : ''
      this.form.asset_acquistion_value = this.item.asset_acquistion_value || ''
      this.form.asset_depreciation_method = this.item.asset_depreciation_method || ''
      this.form.asset_residual_value = this.item.asset_residual_value || ''
      this.form.asset_market_value = this.item.asset_market_value || ''
      this.form.asset_condition = this.item.asset_condition || ''
      this.form.asset_status = this.item.asset_status || 'active'
      this.form.asset_address = this.item.asset_address || ''
      this.form.asset_responsible = this.item.asset_responsible || ''
      this.form.asset_serial_no = this.item.asset_serial_no || ''
      this.form.asset_warranty = this.item.asset_warranty || ''
      this.form.asset_insurance = this.item.asset_insurance || ''
    },
    previous() {
      this.$router.push({ name: 'apps-procurement-assets-list' })
    },
  },
}
</script>

<style scoped>
.asset-photo-card {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 96px;
  height: 96px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 14px;
  background: #f4f6f8;
  box-shadow: 0 4px 14px rgba(20, 30, 50, 0.1);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.asset-photo-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 22px rgba(20, 30, 50, 0.18);
}

.asset-photo-card__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.asset-photo-card__doc {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  color: #7367f0;
  font-size: 0.7rem;
  font-weight: 600;
}

.asset-photo-card__overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
  color: #fff;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  background: linear-gradient(180deg, rgba(15, 23, 42, 0) 40%, rgba(15, 23, 42, 0.72) 100%);
  opacity: 0;
  transition: opacity 0.2s ease;
}

.asset-photo-card:hover .asset-photo-card__overlay {
  opacity: 1;
}

.asset-photo-modal .modal-content {
  overflow: hidden;
  border: 0;
  border-radius: 16px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.35);
}

.asset-photo-modal .modal-body {
  padding: 0;
}

.asset-photo-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.9rem 1.1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  background: #fff;
}

.asset-photo-modal__title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #1f2937;
  font-size: 0.95rem;
  font-weight: 700;
}

.asset-photo-modal__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 0;
  border-radius: 50%;
  background: #f1f2f6;
  color: #4b5563;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.asset-photo-modal__close:hover {
  background: #e94b4b;
  color: #fff;
}

.asset-photo-modal__stage {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 320px;
  padding: 1.5rem;
  background:
    linear-gradient(45deg, #f4f5f7 25%, transparent 25%),
    linear-gradient(-45deg, #f4f5f7 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #f4f5f7 75%),
    linear-gradient(-45deg, transparent 75%, #f4f5f7 75%);
  background-size: 22px 22px;
  background-position: 0 0, 0 11px, 11px -11px, -11px 0;
  background-color: #fafbfc;
}

.asset-photo-modal__img {
  max-width: 100%;
  max-height: 62vh;
  border-radius: 10px;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.22);
}

.asset-photo-modal__doc {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem 1.5rem;
  text-align: center;
}

.asset-photo-modal__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.6rem;
  padding: 0.85rem 1.1rem;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  background: #fff;
}

@media (max-width: 575.98px) {
  .asset-photo-modal__stage {
    min-height: 220px;
    padding: 1rem;
  }
}
</style>
